import { render, staticRenderFns } from "./AddressLists.vue?vue&type=template&id=5775cf3a"
import script from "./AddressLists.vue?vue&type=script&lang=js"
export * from "./AddressLists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports